export const KO = {
  "Open document": "ë¬¸ì ì´ê¸°",
  "Upload file": "íì¼ ìë¡ë",
  "Drop file here to upload": "ìë¡ëíë ¤ë©´ ì¬ê¸°ì íì¼ì ëë¡­íì¸ì.",
  "Disc": "ëì¤í¬",
  "URL": "URL",
  "FILE": "íì¼",
  "SIZE": "í¬ê¸°",
  "MB": "ë©ê°ë°ì´í¸",
  "KB": "KB",
  "Bytes": "ë°ì´í¸",
  "Loading... Please wait.": "ë¡ë© ì¤ ê¸°ë¤ë ¤ì£¼ì¸ì.",
  "Fit Width": "ëë¹ ë§ì¶ê¸°",
  "Fit Height": "ë§ë ëì´",
  "Password protected document": "ìí¸ë¡ ë³´í¸ë ë¬¸ì",
  "Password": "ë¹ë°ë²í¸",
  "Open": "ì´ë ¤ìë",
  "Password Required": "ë¹ë°ë²í¸ê° íìí©ëë¤",
  "Incorrect password": "ìëª»ë ë¹ë°ë²í¸",
  "Error": "ì¤ë¥",
  "Something went wrong": "ë¬¸ì ê° ë°ìíìµëë¤.",
  "Server is not available": "ìë²ë¥¼ ì¬ì©í  ì ììµëë¤",
  "of": "NS",
  "Please wait...": "ê¸°ë¤ë¦¬ì¸ì..."
};
